<template>
  <b-card
    v-if="data.order_groups"
  >
    <b-row no-gutters>
      <b-col>
        <h4 class="card-title">
          Ringkasan Belanja
        </h4>
      </b-col>
      <b-col
        v-if="data.order_groups.order_group_payment.reference_id"
        cols="auto"
        class="text-12"
      >
        <a
          :href="paymentGatewayDetailUrl"
          target="_blank"
        >
          Buka di {{ isXenditPayment ? 'Xendit' : 'Midtrans' }}
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
          />
        </a>
      </b-col>
      <b-col
        v-if="data.order_groups.order_group_payment.reference_id"
        cols="auto"
      >
        <b-dropdown
          variant="white"
          no-caret
          toggle-class="px-1 py-25 mr-n1"
          right
        >
          <template #button-content>
            <feather-icon
              icon="MoreHorizontalIcon"
              size="16"
            />
          </template>
          <b-dropdown-item
            target="_blank"
            :href="paymentGatewayWebhookUrl"
          >
            Lihat Notifikasi
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <dd>
      <dl class="row mb-0">
        <dt class="col-sm-7">
          Total Produk <small>({{ data.order_groups.transactions.length }} Invoice)</small>
        </dt>
        <dd class="col-sm-5 text-right">
          {{ toCurrency(data.order_groups.total_price) }}
        </dd>
      </dl>
      <dl
        v-if="data.order_groups.used_point"
        class="row mb-0"
      >
        <dt class="col-sm-7">
          Potongan Mini Point <small>({{ data.order_groups.used_point }} Poin)</small>
        </dt>
        <dd class="col-sm-5 text-right">
          - {{ toCurrency(data.order_groups.used_point_conversion) }}
        </dd>
      </dl>
      <dl class="row mb-0">
        <dt class="col-sm-5">
          Total Ongkos Kirim
        </dt>
        <dd class="col-sm-7 text-right">
          {{ toCurrency(data.order_groups.delivery_fee) }}
        </dd>
      </dl>
      <dl class="row mb-0">
        <dt class="col">
          Asuransi Pengiriman
        </dt>
        <dd class="col-auto text-right">
          {{ toCurrency(totalInsuranceFee) }}
        </dd>
      </dl>
      <dl class="row mb-0">
        <dt class="col">
          Biaya layanan
        </dt>
        <dd class="col-auto text-right">
          {{ toCurrency(data.order_groups.payment_method_fee) }}
        </dd>
      </dl>

      <hr
        v-if="data.order_groups.order_group_payment.wallet_usage_amount && Number.parseFloat(data.order_groups.order_group_payment.wallet_usage_amount) > 0"
        class="mt-50"
      >

      <dl
        v-if="data.order_groups.order_group_payment.wallet_usage_amount && Number.parseFloat(data.order_groups.order_group_payment.wallet_usage_amount) > 0"
        class="row mb-0"
      >
        <dt class="col-sm-5">
          Total Belanja
        </dt>
        <dd class="col-sm-7 text-right">
          {{ toCurrency(data.total_price + Number.parseFloat(data.order_groups.order_group_payment.wallet_usage_amount)) }}
        </dd>
      </dl>
      <dl
        v-if="data.order_groups.order_group_payment.wallet_usage_amount && Number.parseFloat(data.order_groups.order_group_payment.wallet_usage_amount) > 0"
        class="row mb-0"
      >
        <dt class="col-sm-5">
          Mini Credit
        </dt>
        <dd class="col-sm-7 text-right">
          - {{ toCurrency(Number.parseFloat(data.order_groups.order_group_payment.wallet_usage_amount)) }}
        </dd>
      </dl>

      <hr class="mt-50">

      <dl class="row mb-0">
        <dt class="col-sm-5">
          Total Tagihan
        </dt>
        <dd class="col-sm-7 text-right">
          {{ toCurrency(data.total_price) }}
        </dd>
      </dl>
    </dd>

    <div v-if="data.order_groups.order_group_voucher.length">
      <hr>
      <dd>
        <dl
          v-for="(item, index) in data.order_groups.order_group_voucher"
          :key="`item-voucher-${index}`"
          class="row mb-0"
        >
          <dt class="col-sm-7">
            <div v-if="item.code">
              <b-badge variant="light-success mb-50">
                {{ item.code }}
              </b-badge>
            </div>
            <div
              v-else
              class="mb-50"
            >
              {{ item.name }}
            </div>
            <small class="text-secondary">
              <span>
                Diskon {{ item.type === 'regular' ? 'Produk' : 'Ongkir' }}
                {{ item.discount }} % hingga <span class="text-nowrap">{{ toCurrency(item.max_discount) }}</span>
              </span>
            </small>
          </dt>
          <dd class="col-sm-5 text-right">
            - {{ toCurrency(discountVoucher) }}
          </dd>
        </dl>
      </dd>
    </div>

    <div v-if="data.order_groups.order_group_payment.status === 'paid' && data.order_groups.order_group_payment.payment_method">
      <hr>
      <dd>
        <dl class="row mb-0">
          <dt class="col-sm-6">
            Metode Pembayaran
          </dt>
          <dd class="col-sm-6 text-right">
            {{ data.order_groups.order_group_payment.payment_method.name }}
          </dd>
        </dl>
      </dd>
    </div>
  </b-card>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BCard,
  BBadge,
  VBPopover,
} from 'bootstrap-vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BCard,
    BBadge,
  },
  directives: {
    'b-popover': VBPopover,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      infoPoin: 'Dari total harga produk',
      midtransBaseUrl: process.env.VUE_APP_MIDTRANS_BASE_URL,
    }
  },
  computed: {
    isXenditPayment() {
      return this.data.order_groups?.order_group_payment?.reference_type === 'xendit'
    },
    paymentGatewayDetailUrl() {
      const payment = this.data.order_groups.order_group_payment
      if (this.isXenditPayment) {
        let customId = payment.reference_id
        if (payment.payment_method) {
          if (payment.payment_method.category === 'VA') {
            customId = `va_${payment.reference_id}`
          } else if (payment.payment_method.xendit_code === 'QRIS') {
            customId = `qr_${payment.reference_id}`
          }
        }
        return `https://dashboard.xendit.co/transactions-new/${customId}`
      }
      return `${this.midtransBaseUrl}/beta/transactions?detail=${payment.reference_id}`
    },
    paymentGatewayWebhookUrl() {
      if (this.isXenditPayment) {
        return 'https://dashboard.xendit.co/webhooks'
      }
      const payment = this.data.order_groups.order_group_payment
      return `${this.midtransBaseUrl}/settings/vtweb_configuration/history?q[created_after]=&q[created_before]=&q[order_id]=${payment.id}&q[status]=&q[kind]=&commit=Search`
    },
    discountVoucher() {
      const totalOrder = this.data.total
      let totalDiscount = 0

      this.data.order_groups.order_group_voucher.forEach(item => {
        let discount = totalOrder * (item.discount / 100)
        discount = discount > item.max_discount ? item.max_discount : discount
        totalDiscount += discount
      })

      return totalDiscount
    },
    totalInsuranceFee() {
      let total = 0

      this.data.order_groups.transactions.forEach(item => {
        total += item.delivery_insurance_fee
      })

      return total
    },
  },
}
</script>

<style lang="scss" scoped>
dt {
    font-weight: bolder !important;
}
</style>
